<template>
<div class="tg-coupon pos-r flex-container text-red"
     style="background-image: url('//image1.51tiangou.com/tgou2/img2/coupon/bg-coupon.png')"
     :data-theme="theme">
    <span class="pos-a tg-coupon-type fs-12 top0 left0" style="background: #ffdcdf">
        {{data.detailSubName}}
    </span>
    <div class="tg-coupon-price flex-container">
        <div v-if="data.detailType==='cash'" style="width: 75px">
            <div class="fs-20 line text-center" style="line-height: 33px;margin-top: 10px">
                <span class="lh-20 fs-16">¥</span>
                <span style="font-size: 32px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;max-width: 80px;" v-text="data.detailDes | splitPriceInt"></span>
                <span v-text="data.detailDes | splitPrice"></span>
            </div>
            <div class="fs-12 text-center" v-text="data.detailTips" style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 90px;"></div>
        </div>
        <div v-if="data.detailType==='discount'" style="width: 75px">
            <div class="fs-20 line text-center" style="line-height: 33px;margin-top: 10px">
                <span style="font-size: 33px;" v-text="data.detailDes | splitPriceInt"></span>
                <span v-text="data.detailDes | splitPrice"></span>
                <span class="fs-12">折</span>
            </div>
            <div class="fs-12 text-center" v-text="data.detailTips"></div>
        </div>
        <div v-if="data.detailType==='text'" style="width: 75px">
            <div class="fs-20 line text-center" style="line-height: 32px;margin-top: 10px">
                <span style="font-size: 33px;" v-text="data.detailDes | splitPriceInt"></span>
                <span v-text="data.detailDes | splitPrice"></span>
            </div>
            <div class="fs-10" v-text="data.detailTips"></div>
        </div>
        <div class="flex1" style="margin-left: 17px">
            <div class="tg-coupon_title text-limit1 fs-14" v-text="data.detailName"></div>
            <div v-if="!data.canReceived && data.received">
                <img src="//image1.51tiangou.com/tgou2/img2/coupon/coupon-yilingqu.png" alt="" style="width: 60px;height: 60px;position: absolute;top: 0;right: 0;">
            </div>
            <div class="tg-coupon_store fs-12 text-limit1" style="margin-bottom: 12px" v-text="data.storeName"></div>
            <div class="fs-11" style="color: #ff7684" v-text="data.timeStr"></div>
        </div>
    </div>
    <div v-text="opText" v-if="opText" class="fs-16" @click="getCoupon(data)" style="min-width: 64px"></div>
</div>
</template>

<script>
export default {
	props: {
		data: {
			type: Object,
            default: null
		}
	}
	, methods: {
		getCoupon(data){
            data.canReceived && this.$dispatch('getCoupon', data);
		}
	}
	, computed: {
		theme(){
			if(!this.data.canReceived && !this.data.received){
				return 'grey';
			} else{
                return this.data.colorType;
			}
		}
		, opText(){
            if (this.data.canReceived) {
                return '立即领取'
            } else if (!this.data.received) {
                return '已抢光'
            } else {
                return ''
            }
		}
	}
};
</script>

<style lang="scss">
.tg-coupon {
    margin-bottom: 8px;
    padding: 12px;
    height: 89px;
    background-size: 100% 100%;
}
.tg-coupon:before, .tg-coupon:after {
    display: none;
}
.tg-coupon-type {
    padding: 0 8px;
    border-radius: 8px 0;
    line-height: 21px;
}
.tg-coupon_discount{
	height: 95px;
	width: 100px;
	border: 1px solid;
	border-right: 0;
    z-index: -1;
}
.tg-coupon_discount:after{
    position: absolute;
    content: '';
    width: 8px;
    height: 80px;
    background: radial-gradient(#fff 0px, #fff 2px, rgba(0, 0, 0, 0) 2px, rgba(0, 0, 0, 0) 2px);
    background-size: 9px 9px;
    background-position: -9px -9px;
    left: 94px;
    top: 6px;
}
.tg-coupon_title .badge{
	height: 13px;
	padding: 0 5px;
	font-size: 10px;
	line-height: 13px;
}
.tg-coupon_operate{
	height: 22px;
	line-height: 22px;
	border-radius: 10px;
}
</style>